/* The logomark itself (outline, gradient flow, pulsed spin, reduced-motion
   fallbacks) lives in arch-ui's BrandSpinner; this file styles only the
   screen-variant ambience around it. */

/* Screen-variant rhythm: one soft revolution (the first half of the cycle)
   starting exactly as each status message swaps in, then rest until the next.
   The 2.4s cycle must equal MESSAGE_INTERVAL_MS in ShapeLoader.tsx — both the
   interval and this animation start at mount, so they stay in step. */
.shape-loader-step-spin {
  animation: shape-loader-step-spin 2.4s infinite;
}

@keyframes shape-loader-step-spin {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* One ambient gradient wash across the whole loading surface, Gemini-style:
   a strong glow rising from the bottom with cooler accents in the corners,
   drifting slowly. Oversized so the drift never exposes its edges. */
.shape-loader-backdrop {
  position: absolute;
  inset: -10%;
  pointer-events: none;
  background:
    radial-gradient(90% 75% at 50% 108%, color-mix(in srgb, var(--color-indigo-500) 18%, transparent), transparent 65%),
    radial-gradient(70% 60% at -5% -8%, color-mix(in srgb, var(--color-blue-400) 12%, transparent), transparent 65%),
    radial-gradient(75% 65% at 106% 28%, color-mix(in srgb, var(--color-purple-500) 13%, transparent), transparent 65%);
  animation: shape-loader-backdrop-drift 12s ease-in-out infinite alternate;
}

@keyframes shape-loader-backdrop-drift {
  from {
    transform: translate3d(-1.5%, -1%, 0) scale(1);
  }
  to {
    transform: translate3d(1.5%, 1.5%, 0) scale(1.06);
  }
}

.shape-loader-message {
  animation: shape-loader-message-in 400ms ease-out;
}

@keyframes shape-loader-message-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .shape-loader-backdrop,
  .shape-loader-message,
  .shape-loader-step-spin {
    animation: none;
  }
}
